import { Grid, Button, Text, Flex } from '@raskrask-dk/rr-components'
import { t } from 'i18next'
import { TimeSlot } from '@raskrask-dk/rr-components/lib/Organisms/ProductModal/Tabs/Book/props'
import { RRDate } from '@raskrask-dk/raskrask-utils'
import React from 'react'
import { IButtonHandler } from '../../modifybooking/props'
import { useAppSelector } from '../../../redux/hooks'
import { getIsMobile } from '../../../redux/reducers/appSettings'

export const ModifyBookTimeSlotsComponent = (
    timeSlots: TimeSlot[],
    time: string | undefined,
    setTime: (value: string | undefined) => void,
    date: RRDate | undefined,
    antiSpam: boolean,
    buttonsArray: IButtonHandler[]
): React.ReactFragment => {
    const isMobile = useAppSelector((state) => getIsMobile(state))
    if (timeSlots.length < 0) return <></>
    const buttons = buttonsArray.map((button) => {
        if (button.shouldShowButton)
            return CTAButton(
                button.onClickHandler,
                button.isClickable,
                antiSpam,
                button.buttonName
            )
        else return <></>
    })
    return (
        <Grid gap={16}>
            <Grid gap={4}>
                <Text primary>
                    {timeSlots.length > 0
                        ? t('movebooking.timeslots.title')
                        : ''}
                </Text>
                <Grid
                    gap="8"
                    css={{
                        gridTemplateColumns:
                            'repeat(auto-fill, minmax(75px, 1fr))',

                        '@desktop': {
                            maxW: 550,
                        },
                        '@mobile': { pb: 125 },
                    }}
                >
                    {timeSlots.map((timeSlot) => {
                        const isSelected = timeSlot.time === time
                        return (
                            <Button
                                active={isSelected}
                                data-cy={`timeslot_${timeSlot.time}`}
                                key={timeSlot.time}
                                onClick={() => setTime(timeSlot.time)}
                                size="large"
                                variant="option"
                            >
                                {timeSlot.time}
                            </Button>
                        )
                    })}
                </Grid>
            </Grid>
            <Flex direction={isMobile ? 'column' : 'row'} gap={'32'}>
                <Grid
                    gap="4"
                    css={{
                        '@mobile': {
                            background:
                                'linear-gradient(to top, $white 65%, rgba(255, 255, 255, 0) 100%)',
                            bottom: 0,
                            left: 0,
                            p: '$3',
                            position: 'fixed',
                            right: 0,
                            zIndex: 200000000000,
                        },
                        '@desktop': {
                            gridAutoFlow: 'row',
                        },
                    }}
                >
                    {date && (
                        <Flex>
                            <Text primary>{t('movebooking.newtime')}:</Text>
                            <Text
                                bold
                                primary
                                css={{ textTransform: 'capitalize', ml: '$1' }}
                            >
                                {`${date.toString('EEEE')} ${date.toString(
                                    'd/M'
                                )}, ${
                                    time
                                        ? time
                                        : t('calendar.modal.book.choosetime')
                                }`}
                            </Text>
                        </Flex>
                    )}
                    <Flex
                        direction={isMobile ? 'column' : 'row'}
                        gap={'16'}
                        data-cy="ModifyBookButtonDiv"
                    >
                        {buttons}
                    </Flex>
                </Grid>
            </Flex>
        </Grid>
    )
}

const CTAButton = (
    onClickFunction: () => void,
    isClickable: boolean,
    antiSpam: boolean,
    buttonName: string
) => {
    return (
        <Flex gap="8">
            <Button
                onClick={onClickFunction}
                size="large"
                variant={buttonName === 'MoveCTA' ? 'success' : 'danger'}
                data-cy={`${buttonName}Button`}
                disabled={!isClickable && !antiSpam}
                css={{ '@mobile': { w: '100%' } }}
            >
                {buttonName === 'MoveCTA'
                    ? t('movebooking.confirmtime')
                    : 'Aflys Booking'}
            </Button>
        </Flex>
    )
}
